<div class="qtr-edit-page" *ngIf="ready">

  <!-- Cabecera -->
  <div class="qtr-edit-header">
    <button mat-icon-button (click)="cancel()" matTooltip="Volver al listado">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div>
      <h1 class="qtr-edit-header__title">{{ model?.uid ? 'Editar justificante' : 'Nuevo justificante' }}</h1>
      <p class="qtr-edit-header__sub">Rellena los datos y adjunta el documento si lo tienes</p>
    </div>
  </div>

  <!-- Tarjeta principal -->
  <div class="qtr-card">
    <div class="qtr-card__head">
      <mat-icon>receipt</mat-icon>
      <span class="qtr-card__head-label">Justificante</span>
    </div>
    <div class="qtr-card__body">
      <div class="qtr-edit-layout">

        <!-- Columna formulario -->
        <div class="qtr-edit-layout__form">
          <div class="qtr-fields">
            <app-input inputType="text" placeholder="Número de justificante" name="model.receiptNumber"
              [(ngModel)]="model.receiptNumber"></app-input>
            <app-input inputType="number" placeholder="Ejercicio" name="model.taxYear"
              [(ngModel)]="model.taxYear"></app-input>
            <app-input inputType="text" placeholder="Periodo" name="model.period"
              [(ngModel)]="model.period"></app-input>
            <app-input inputType="text" placeholder="Modelo" name="model.taxFormModel"
              [(ngModel)]="model.taxFormModel"></app-input>
            <app-input inputType="number" placeholder="Importe (€)" name="model.amount"
              [(ngModel)]="model.amount"></app-input>
          </div>

          <div class="qtr-save-bar">
            <button mat-flat-button class="qtr-btn-save" (click)="save()">
              <mat-icon>save</mat-icon>
              Guardar
            </button>
            <button mat-stroked-button (click)="cancel()">
              Cancelar
            </button>
          </div>
        </div>

        <!-- Columna documento -->
        <div class="qtr-edit-layout__doc">
          <div class="qtr-doc-wrap">

            <app-add-file [originEntity]="originEntity" [filePath]="filePath" [imageTempUrl]="imageTempUrl"
              [showConvfactFiles]="true" (CallbackParameters)="SetFileParameters($event)"></app-add-file>

            <ng-container *ngIf="readyLoadedFiles === false">
              <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
            </ng-container>

            <div *ngIf="imageTempUrl != null">
              <ng-container *ngIf="model.pdf">
                <div class="qtr-pdf-preview">
                  <ngx-extended-pdf-viewer [src]="imageTempUrl" [useBrowserLocale]="true"
                    [height]="'100%'" [textLayer]="false">
                  </ngx-extended-pdf-viewer>
                </div>
              </ng-container>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>

</div>
